export default "__VITE_ASSET__CZPRix$6__"